var map = {
	"../app/pages/blank/blank.module": [
		"./src/app/pages/blank/blank.module.ts",
		"app-pages-blank-blank-module"
	],
	"../app/pages/chapel-panel/chapel-panel.module": [
		"./src/app/pages/chapel-panel/chapel-panel.module.ts",
		"app-pages-chapel-panel-chapel-panel-module"
	],
	"../app/pages/unauthorized/unauthorized.module": [
		"./src/app/pages/unauthorized/unauthorized.module.ts",
		"app-pages-unauthorized-unauthorized-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;